module.exports = __webpack_public_path__ + "static/assets/03bd480912e01b6328db7bebe2ddc598.png";